import * as actionTypes from "./action_types";
import {  LANGUAGE_ID } from "../constants";

export const fetchLanguagesFailed = () => {
  return {
    type: actionTypes.LANGUAGES_FAILED
  };
};
export const languageChanged = language => {
  return {
    type: actionTypes.LANGUAGE_CHANGED,
    language: language
  };
};
export const changeLanguage = id => {
  localStorage.setItem(LANGUAGE_ID, id);
  return dispatch => {
    dispatch(startLoading());
    setTimeout(() => {
    dispatch(languageChanged(id));
    dispatch(endLoading());
    }, 200);
  };
};

export const startLoading = () => {
  return {
    type: actionTypes.CHANGE_LANGUAGE_STARTED
  };
};
export const endLoading = () => {
  return {
    type: actionTypes.CHANGE_LANGUAGE_END
  };
};
export const getSelectedLanguage = (languageId) => {
  localStorage.setItem(LANGUAGE_ID, languageId);
  return dispatch => {
    let language = parseInt(localStorage.getItem(LANGUAGE_ID));
    // if (!language) language = 1; //default is english when nothig selected
    dispatch(languageChanged(language));
    dispatch(changeLanguage(languageId));
  };
};

